import config from '../config.json';

// Determine environment (mirrors logic in index.jsx)
const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname === 'mfsimulator.jnjvision.com') return 'production';
  return 'staging';
};

/**
 * Inject the OneTrust SDK stub and OptanonWrapper into <head> for ja-jp.
 * Safe to call multiple times — guards against duplicate injection.
 *
 * Production domain script: 019faea0-1dbc-7216-972a-ff99371251ea
 * Staging domain script:    019faed0-088b-71a8-bfc9-262f80a36f8c-test
 */
export const injectOneTrust = () => {
  // Only inject for ja-jp paths
  if (!window.location.pathname.startsWith('/ja-jp')) return;

  // Guard against duplicate injection (e.g. React re-renders or HMR)
  if (document.querySelector('script[data-domain-script]')) return;

  const environment = getEnvironment();
  const oneTrustConfig = config.onetrust['ja-jp'];
  const domainScript = oneTrustConfig[environment];

  // OptanonWrapper callback must be defined before the SDK stub loads
  const wrapperScript = document.createElement('script');
  wrapperScript.type = 'text/javascript';
  wrapperScript.textContent = 'function OptanonWrapper() {}';
  document.head.prepend(wrapperScript);

  // Main OneTrust SDK stub — prepend so consent loads before GTM fires
  const sdkScript = document.createElement('script');
  sdkScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  sdkScript.setAttribute('data-document-language', 'true');
  sdkScript.type = 'text/javascript';
  sdkScript.charset = 'UTF-8';
  sdkScript.setAttribute('data-domain-script', domainScript);
  document.head.prepend(sdkScript);
};
